import React from 'react';
import { SVGProps } from './types';

function AttachmentIcon(props: SVGProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      {...props}
    >
      <g clipPath="url(#clip0_808_524)">
        <path
          fill="currentColor"
          d="M13.447 5.455v8.712a3.03 3.03 0 11-6.06 0v-9.47a1.895 1.895 0 013.787 0v7.955a.76.76 0 01-.757.757.76.76 0 01-.758-.757V5.455H8.523v7.197a1.895 1.895 0 003.788 0V4.697a3.03 3.03 0 10-6.061 0v9.47a4.164 4.164 0 004.167 4.166 4.164 4.164 0 004.166-4.166V5.455h-1.136z"
        />
      </g>
      <defs>
        <clipPath id="clip0_808_524">
          <path fill="#fff" d="M0 0H20V20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export { AttachmentIcon };
